"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@Const/common");
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const WriterLabel = (props) => {
    const { linkedWriter, isAmendable, removeWriter } = props;
    return (react_1.default.createElement("div", { className: 'item', key: linkedWriter.localId },
        react_1.default.createElement("p", { className: 'bold small-2', title: `${linkedWriter.firstName ? linkedWriter.firstName : ''} ${linkedWriter.lastName ? linkedWriter.lastName : ''}` },
            linkedWriter.firstName,
            " ",
            linkedWriter.lastName),
        isAmendable && (react_1.default.createElement("div", { className: 'button', onClick: () => removeWriter(linkedWriter) },
            react_1.default.createElement("img", { src: common_1.ICONS.close, alt: "remove" })))));
};
exports.default = (0, mobx_react_1.observer)(WriterLabel);
